function tabsCreate() {
  $(".my-tabs").click(function(){
      const tab_group = $(this).data('rel')
      $(".my-tabs[data-rel='"+ tab_group +"']").removeClass("active")
      $(this).addClass("active")
      $(".my-tabs-content[data-rel='"+ tab_group +"']").hide()
      $("#"  + $(this).attr("data-content")).fadeIn();
  });
}

function tabsInit() {
  $(".my-tabs-content").hide()
  $(".my-tabs.active").each(function(){
      const tab_ativa = $(this).attr("data-content")
      $("#" + tab_ativa).show()
  });
  $('.my-tabs-content .btn-close-tab').on('click', function(e){
    const target = $(this).parent('.my-tabs-content').attr('id')
    const tab_group = $(this).parent('.my-tabs-content').data('rel')
    $(`[data-content='${target}']`).removeClass('active')
    $(this).parent('.my-tabs-content').hide()

    // if ( tab_group == 'menu-models' ){
    //   $('.header').removeClass('active')
    // } else if (tab_group == 'menu-models-fixed'){
    //   $('.rick').removeClass('active')
    // }

  })
  $('.my-tabs-content .btn-close-menu').on('click', function(e){
    const target = $('.jerry').removeClass('open')
    $('.cars-dropdown-c').fadeOut('fast')
    // const target = $(this).parent('.my-tabs-content').attr('id')
    // const tab_group = $(this).parent('.my-tabs-content').data('rel')
    // $(`[data-content='${target}']`).removeClass('active')
    // $(this).parent('.my-tabs-content').hide()


  })
}

module.exports ={
  tabsCreate,
  tabsInit
}
